module.exports = __webpack_public_path__ + "static/img/33汇创.777171d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/33汇创.jpg
// module id = 9YgQ
// module chunks = 1